import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getGalleryById } from "../../../services/galleryServices";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Calendar } from "lucide-react";

const GalleryDetails = () => {
  const [searchParams] = useSearchParams();
  const galleryId = searchParams.get("galleryId");

  const isValidGalleryId = !!galleryId && /^[a-f\d]{24}$/i.test(galleryId);

  const {
    data: galleryData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["galleries", galleryId],
    queryFn: () => getGalleryById(galleryId),
    enabled: isValidGalleryId,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  return (
    <>
      <Header />

      <main className="min-h-screen p-4 md:p-8 mb-[40px]">
        {galleryData && (
          <div className="max-w-7xl mx-auto">
            <div className="text-sm breadcrumbs mb-6">
              <ul className="flex items-center flex-wrap gap-2">
                <li>
                  <a href="/">Home</a>
                </li>
                <span>/</span>
                <li>
                  <a href="/gallery">Gallery</a>
                </li>
                <span>/</span>
                <li className="text-primary">{galleryData?.name || "Event"}</li>
              </ul>
            </div>

            <div className="mb-8">
              <h1 className="text-xl  md:text-3xl font-semibold text-black mb-2">
                {galleryData.name}
              </h1>

              <p className="text-black text-sm font-medium flex items-center gap-2 mb-3 md:mb-4">
                <Calendar className="w-4 h-4 text-black" />
                Created on:{" "}
                {new Date(galleryData.createdAt).toLocaleDateString("en-IN", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              <p className="text-grey leading-relaxed">
                {galleryData.description}
              </p>
            </div>

            {/* Masonry Image Grid */}
            <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
              {galleryData?.images?.map((src, index) => (
                <div
                  key={index}
                  className="break-inside-avoid overflow-hidden rounded-xl shadow bg-white hover:shadow-lg transition-shadow duration-300"
                >
                  <img
                    src={src}
                    alt={`Gallery Image ${index}`}
                    className="w-full h-auto object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default GalleryDetails;
